// create sagas
import { call, put, takeLatest, takeEvery, delay } from "redux-saga/effects";
import {
  getUtilityData,
  getUtilityDataSuccess,
  getUtilityDataFailure,
  getAdminEngagementData,
  getAdminEngagementDataSuccess,
  getAdminEngagementDataFailure,
  getAdminFilesData,
  getAdminFilesDataSuccess,
  getAdminFilesDataFailure,
  getFilesEngagementData,
  getFilesEngagementDataSuccess,
  getFilesEngagementDataFailure,
  getPartnerFilesBlocklistData,
  getPartnerFilesBlocklistDataSuccess,
  getPartnerFilesBlocklistDataFailure,
  getPartnersEditEngagementDetailsSuccess,
  getPartnersEditEngagementDetailsFailure,
  getPartnerEditEngagementDetailsUS,
  getPartnerEditEngagementDetailsEU,
  getPartnerEditEngagementDetailsAU,
  getPartnersFileValidationUS,
  getPartnersFileValidationEU,
  getPartnersFileValidationAU,
  getPartnersFileValidationSuccess,
  getPartnersFileValidationFailure,
  getPartnersFilesDeleteUS,
  getPartnersFilesDeleteEU,
  getPartnersFilesDeleteAU,
  getPartnersFilesDeleteSuccess,
  getPartnersFilesDeleteFailure,
  getPartnersViewFilesContentUS,
  getPartnersViewFilesContentEU,
  getPartnersViewFilesContentAU,
  getPartnersViewFilesContentSuccess,
  getPartnersViewFilesContentFailure,
  PartnersDeleteTempFilesOnPopupCloseUS,
  PartnersDeleteTempFilesOnPopupCloseEU,
  PartnersDeleteTempFilesOnPopupCloseAU,
  PartnersDeleteTempFilesOnPopupCloseSuccess,
  PartnersDeleteTempFilesOnPopupCloseFailure,
  getPartnersFilesDownloadUS,
  getPartnersFilesDownloadEU,
  getPartnersFilesDownloadAU,
  getPartnersFilesDownloadSuccess,
  getPartnersFilesDownloadFailure,
  partnersEditEngagementStatusUS,
  partnersEditEngagementStatusEU,
  partnersEditEngagementStatusAU,
  partnersEditEngagementStatusSuccess,
  partnersEditEngagementStatusFailure,
  partnersSasTokenUS,
  partnersSasTokenEU,
  partnersSasTokenAU,
  partnersSasTokenSuccess,
  partnersSasTokenFailure,
  partnersUploadProcessingUS,
  partnersUploadProcessingEU,
  partnersUploadProcessingAU,
  partnersUploadProcessingSuccess,
  partnersUploadProcessingFailure,
  partnersUploadReProcessingUS,
  partnersUploadReProcessingEU,
  partnersUploadReProcessingAU,
  partnersUploadReProcessingSuccess,
  partnersUploadReProcessingFailure,
  partnersUploadSharePointFilesToBlobUS,
  partnersUploadSharePointFilesToBlobEU,
  partnersUploadSharePointFilesToBlobAU,
  partnersUploadSharePointFilesToBlobSuccess,
  partnersUploadSharePointFilesToBlobFailure,
  partnersAccessGrantUS,
  partnersAccessGrantEU,
  partnersAccessGrantAU,
  partnersAccessGrantSuccess,
  partnersAccessGrantFailure,
  partnersAccessRevokeUS,
  partnersAccessRevokeEU,
  partnersAccessRevokeAU,
  partnersAccessRevokeSuccess,
  partnersAccessRevokeFailure,
  partnersUploadCountsSuccess,
  partnersUploadCountsBulkSuccess,
  partnersUploadCountsFailure,
  partnersUploadCountSingleRequest
  , adminOriginalFileNamesRequest
  , adminOriginalFileNamesSuccess
  , adminOriginalFileNamesFailure
  , adminStartAnonymizationRequest
  , adminStartAnonymizationSuccess
  , adminStartAnonymizationFailure
  , adminDownloadFileRequest
  , adminDownloadFileSuccess
  , adminDownloadFileFailure
  , adminExportExcelRequest
  , adminExportExcelSuccess
  , adminExportExcelFailure
  , adminUploadFileRequest
  , adminUploadFileSuccess
  , adminUploadFileFailure
  , adminGoldCountsRequest
  , adminGoldCountsSuccess
  , adminGoldCountsFailure
  , adminBookmarkFileRequest
  , adminBookmarkFileSuccess
  , adminBookmarkFileFailure,
  partnersUploadedFileStatusRequestUS,
  partnersUploadedFileStatusRequestEU,
  partnersUploadedFileStatusRequestAU,
  partnersUploadedFileStatusSuccess,
  partnersUploadedFileStatusFailure,
  partnersDuplicateFilesRequestUS,
  partnersDuplicateFilesRequestEU,
  partnersDuplicateFilesRequestAU,
  partnersDuplicateFilesSuccess,
  partnersDuplicateFilesFailure,
  partnersEnableDisableClientDataRequestUS,
  partnersEnableDisableClientDataRequestEU,
  partnersEnableDisableClientDataRequestAU,
  partnersEnableDisableClientDataSuccess,
  partnersEnableDisableClientDataFailure,
  partnersErrorSaveDataRequest,
  partnersErrorSaveDataSuccess,
  partnersErrorSaveDataFailure,
  getPlannedOutagePriorRequest,
  getPlannedOutagePriorSuccess,
  getPlannedOutagePriorFailure,
  getPlannedOutageActiveRequest,
  getPlannedOutageActiveSuccess,
  getPlannedOutageActiveFailure,
  partnersDownloadArcArchivesRequest,
  partnersDownloadArcArchivesSuccess,
  partnersDownloadArcArchivesFailure,
  resetPartnersDownloadArcArchives
} from "./partnerFileUploadSlice";
import {
  apiQueryToUploadDataRegional,
  apiQueryWithToken,
  apiQueryToDownloadData,
  apiQueryWithTokenRegional
} from "../../../common/services/apiBaseUrlConfig";
import { ENDPOINT } from "../../../common/services/endpoint.config";
import logger from "../../../common/utils/logger";

// Monotonic version counter to prevent stale responses overwriting fresher ones
let uploadCountsVersion = 0;
const UPLOAD_COUNT_REQUEST_INTERVAL_MS = Math.max(
  Number(process.env.REACT_APP_UPLOAD_COUNT_REQUEST_INTERVAL_MS) || 3000,
  250
);
const UPLOAD_COUNT_DEDUP_WINDOW_MS = Math.max(
  Number(process.env.REACT_APP_UPLOAD_COUNT_DEDUP_WINDOW_MS) || 5000,
  UPLOAD_COUNT_REQUEST_INTERVAL_MS
);
const recentUploadCountRequests = new Map();
const inFlightUploadCountRequests = new Set();

const getUploadCountRequestKey = (item) =>
  `${String(item?.area || "").toLowerCase()}:${item?.engagementId_GUID}`;

function* waitForUploadCountRateLimit() {
  const now = Date.now();
  const scheduledAt = Math.max(now, uploadCountNextRequestAt);
  uploadCountNextRequestAt = scheduledAt + UPLOAD_COUNT_REQUEST_INTERVAL_MS;
  if (scheduledAt > now) {
    yield delay(scheduledAt - now);
  }
}

let uploadCountNextRequestAt = 0;

export const resetUploadCountRateLimiter = () => {
  recentUploadCountRequests.clear();
  inFlightUploadCountRequests.clear();
  uploadCountNextRequestAt = 0;
};

function* postUploadCountWithRetry(item, shouldRateLimit = true) {
  const maxRetries = 4;
  for (let attempt = 0; attempt <= maxRetries; attempt += 1) {
    if (shouldRateLimit) {
      yield* waitForUploadCountRateLimit();
    }
    const key = getUploadCountRequestKey(item);
    recentUploadCountRequests.set(key, Date.now());
    try {
      return yield call(() =>
        apiQueryWithToken.post(ENDPOINT.PARTNERS_GET_TOTAL_UPLOAD_FILE_COUNT, {
          region: item.area,
          engagementId_GUID: item.engagementId_GUID
        })
      );
    } catch (error) {
      const status = error?.response?.status;
      if (status !== 429 || attempt === maxRetries) {
        throw error;
      }

      const retryAfterHeader = error?.response?.headers?.["retry-after"];
      const retryAfterSeconds = Number(retryAfterHeader);
      const retryDelay = Number.isFinite(retryAfterSeconds) && retryAfterSeconds > 0
        ? retryAfterSeconds * 1000
        : 2000 * (attempt + 1);
      if (shouldRateLimit) {
        uploadCountNextRequestAt = Math.max(
          uploadCountNextRequestAt,
          Date.now() + retryDelay
        );
      } else {
        yield delay(retryDelay);
      }
    }
  }
}

const getUploadStatusValue = (rec) => {
  const statusValue = rec?.uploaD_STATUS ?? rec?.uploadStatus ?? rec?.status ?? null;
  return typeof statusValue === 'string' ? statusValue.trim() : statusValue;
};

// Helper: fetch single engagement upload count
function* fetchSingleUploadCount(item, shouldRateLimit = true, force = false) {
  const key = getUploadCountRequestKey(item);
  const lastRequestedAt = recentUploadCountRequests.get(key) || 0;
  // Forced refreshes follow a user action that just changed the counts (e.g. file deletion),
  // so they must not be dropped by the dedup window - the cached counts would stay stale.
  if (
    inFlightUploadCountRequests.has(key)
    || (!force && Date.now() - lastRequestedAt < UPLOAD_COUNT_DEDUP_WINDOW_MS)
  ) {
    return;
  }

  inFlightUploadCountRequests.add(key);
  try {
    const response = yield* postUploadCountWithRetry(item, shouldRateLimit);
    const arr = response?.data;
    if (Array.isArray(arr) && arr.length > 0) {
      const rec = arr[0];
      yield put(partnersUploadCountsSuccess({
        engagementId_GUID: rec.engagementId_GUID || item.engagementId_GUID,
        totalPendingFile: rec.totalPendingFile,
        noOfUploadedFiles: rec.noOfUploadedFiles,
        uploaD_STATUS: getUploadStatusValue(rec),
        _version: ++uploadCountsVersion
      }));
    }
  } catch (e) {
    yield put(partnersUploadCountsFailure(e.message));
  } finally {
    inFlightUploadCountRequests.delete(key);
  }
}

const hasUploadCountFields = (row) =>
  row?.totalPendingFile !== undefined
  || row?.noOfUploadedFiles !== undefined
  || row?.engagementTrackingStatus !== undefined;

// Utility data carries each engagement's upload counts and status, so seed the
// upload-count store from it instead of calling GetTotalUploadFileCount per engagement.
function* seedUploadCountsFromUtility(action) {
  const list = action.payload;
  if (!Array.isArray(list) || list.length === 0) return;
  const seen = new Set();
  const counts = [];
  list.forEach(row => {
    const guid = row?.engagementId_GUID;
    // Rows missing the count fields keep their existing counts instead of being blanked out.
    if (!guid || seen.has(guid) || !hasUploadCountFields(row)) return;
    seen.add(guid);
    const status = row.engagementTrackingStatus;
    counts.push({
      engagementId_GUID: guid,
      totalPendingFile: row.totalPendingFile,
      noOfUploadedFiles: row.noOfUploadedFiles,
      uploaD_STATUS: typeof status === 'string' ? status.trim() : status,
      _version: ++uploadCountsVersion
    });
  });
  if (counts.length > 0) {
    yield put(partnersUploadCountsBulkSuccess(counts));
  }
}

function* getUtilityDatas(action) {
  try {
    const response = yield call(() =>
      apiQueryWithToken.post(ENDPOINT.GET_PARTNERS_UTILITYDATA, action.payload)
    );
    const responseData = response.data;
    yield put(getUtilityDataSuccess(responseData));
  } catch (error) {
    yield put(getUtilityDataFailure(error.message));
  }
}

function* getAdminEngagementDatas(action) {
  try {
    const response = yield call(() =>
      apiQueryWithToken.post(ENDPOINT.GET_ADMIN_ENGAGEMENT_DATA, action.payload)
    );
    const responseData = response.data;
    yield put(getAdminEngagementDataSuccess(responseData));
  } catch (error) {
    yield put(getAdminEngagementDataFailure(error.message));
  }
}

function* getAdminFilesDatas(action) {
  try {
    const response = yield call(() =>
      apiQueryWithToken.post(ENDPOINT.GET_ADMIN_FILES_DATA, action.payload)
    );
    const responseData = response.data;
    const engagementGUID = action.payload.engagementGUID;
    yield put(getAdminFilesDataSuccess({ engagementGUID, data: responseData }));
  } catch (error) {
    const engagementGUID = action.payload.engagementGUID;
    yield put(getAdminFilesDataFailure({ engagementGUID, error: error.message }));
  }
}

// Admin original file names per engagement (XHR via saga)
function* getAdminOriginalFileNamesDatas(action) {
  try {
    const { engagementGUID, area } = action.payload || {};
    if (!engagementGUID) return;
    const resolveBaseUrl = (areaName) => {
      const a = (areaName || '').toLowerCase();
      if (a === 'americas') return process.env.REACT_APP_API_URL_US;
      if (a === 'emeia') return process.env.REACT_APP_API_URL_EU;
      if (a === 'apac') return process.env.REACT_APP_API_URL_AU;
      return process.env.REACT_APP_API_URL_US;
    };
    const base = resolveBaseUrl(area);
    const url = `${base}/${ENDPOINT.GET_ADMIN_ORIGINAL_FILE_NAMES}`;
    const response = yield call(() => apiQueryWithToken.post(url, { engagementGUID }));
    const responseData = response.data;
    yield put(adminOriginalFileNamesSuccess({ engagementGUID, data: responseData }));
  } catch (error) {
    const { engagementGUID } = action.payload || {};
    yield put(adminOriginalFileNamesFailure({ engagementGUID, error: error.message }));
  }
}

// Admin start anonymization
function* getAdminStartAnonymizationDatas(action) {
  try {
    const { engagementGUID, area, blobFileNames } = action.payload || {};
    const normalizedArea = typeof area === 'string' && area.trim() ? area.trim() : 'Americas';
    const normalizedBlobFileNames = Array.isArray(blobFileNames)
      ? blobFileNames.filter(Boolean)
      : (typeof blobFileNames === 'string'
        ? blobFileNames.split(',').map(name => name.trim()).filter(Boolean)
        : []);
    if (!engagementGUID || normalizedBlobFileNames.length === 0) return;
    const resolveBaseUrl = (areaName) => {
      const a = (areaName || '').toLowerCase();
      if (a === 'americas') return process.env.REACT_APP_API_URL_US;
      if (a === 'emeia') return process.env.REACT_APP_API_URL_EU;
      if (a === 'apac') return process.env.REACT_APP_API_URL_AU;
      return process.env.REACT_APP_API_URL_US;
    };
    const base = resolveBaseUrl(normalizedArea);
    const url = `${base}/${ENDPOINT.ADMIN_START_ANONYMIZATION}`;
    const blobFileNamesValue = normalizedBlobFileNames.join(',');
    logger.info('[Saga] Start anonymization request', { engagementGUID, area: normalizedArea, count: normalizedBlobFileNames.length });
    const response = yield call(() => apiQueryWithToken.post(url, {
      Area: normalizedArea,
      blobFileNames: blobFileNamesValue
    }));
    const message = response?.data?.message || 'Anonymization started';
    yield put(adminStartAnonymizationSuccess({ engagementGUID, message }));
  } catch (error) {
    const { engagementGUID } = action.payload || {};
    yield put(adminStartAnonymizationFailure({ engagementGUID, error: error.message }));
  }
}

// Admin file download moved from component to saga
function* adminDownloadFileSaga(action) {
  try {
    const { fileName, area } = action.payload || {};
    if (!fileName) return;
    const resolveBaseUrl = (areaName) => {
      const a = (areaName || '').toLowerCase();
      if (a === 'americas') return process.env.REACT_APP_API_URL_US;
      if (a === 'emeia') return process.env.REACT_APP_API_URL_EU;
      if (a === 'apac') return process.env.REACT_APP_API_URL_AU;
      return process.env.REACT_APP_API_URL_US;
    };
    const base = resolveBaseUrl(area);
    const url = `${base}/api/admin/databricks/downloadfile`;
    const resp = yield call(() => apiQueryWithTokenRegional.post(url, { fileName }, { responseType: 'blob' }));
    if (resp.status !== 200 || !resp.data) {
      throw new Error(`Download failed: ${resp.status}`);
    }
    const blob = resp.data instanceof Blob ? resp.data : new Blob([resp.data]);
    const dlUrl = window.URL.createObjectURL(blob);
    try {
      const a = document.createElement('a');
      a.href = dlUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } finally {
      window.URL.revokeObjectURL(dlUrl);
    }
    yield put(adminDownloadFileSuccess({ fileName }));
  } catch (error) {
    yield put(adminDownloadFileFailure({ fileName: action.payload?.fileName, error: error.message }));
  }
}

// Admin export excel (filtered payload)
function* adminExportExcelSaga(action) {
  try {
    const payload = action.payload ?? null;
    const response = yield call(() =>
      apiQueryWithToken.post(ENDPOINT.ADMIN_EXPORT_EXCEL_FILTERED_DATA, payload, { responseType: 'blob' })
    );

    if (!response || response.status !== 200 || !response.data) {
      throw new Error('Excel export failed');
    }

    const blob = response.data instanceof Blob ? response.data : new Blob([response.data]);
    const contentDisposition = response?.headers?.['content-disposition'] || response?.headers?.['Content-Disposition'];
    const fileNameMatch = contentDisposition && contentDisposition.match(/filename\*?=(?:UTF-8''|\")?([^;\"]+)/i);
    const resolvedFileName = fileNameMatch ? decodeURIComponent(fileNameMatch[1].replace(/\"/g, '').trim()) : `admin_filtered_export_${Date.now()}.xlsx`;

    const url = window.URL.createObjectURL(blob);
    try {
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = resolvedFileName;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
    } finally {
      window.URL.revokeObjectURL(url);
    }

    yield put(adminExportExcelSuccess({ fileName: resolvedFileName, downloadedAt: Date.now() }));
  } catch (error) {
    yield put(adminExportExcelFailure(error?.message || 'Export failed'));
  }
}

// Admin manual upload saga (multipart form-data)
function* adminUploadFileSaga(action) {
  try {
    const { files, area, requestId } = action.payload || {};
    if (!files || files.length === 0) return;

    // Resolve base URL per area (same logic as download)
    const resolveBaseUrl = (areaName) => {
      const a = (areaName || '').toLowerCase();
      if (a === 'americas') return process.env.REACT_APP_API_URL_US;
      if (a === 'emeia') return process.env.REACT_APP_API_URL_US;
      if (a === 'apac') return process.env.REACT_APP_API_URL_US;
      return process.env.REACT_APP_API_URL_US;
    };
    const base = resolveBaseUrl(area);
    const url = `${base}/api/admin/databricks/uploadfile`;

    // Build one FormData payload appending each file under the required field name 'File'.
    // Repeated keys are supported by multipart and commonly bound to IFormFileCollection in .NET.
    const formData = new FormData();
    files.forEach(f => {
      if (f) formData.append('File', f, f.name);
    });
    // Include simple metadata to help backend (optional, harmless).
    formData.append('Area', area || '');
    formData.append('RequestTimestamp', new Date().toISOString());
    formData.append('RequestId', requestId || '');

    // Use apiQueryToUploadDataRegional which does NOT force 'application/json' Content-Type header.
    // The interceptor will still inject Authorization.
    const resp = yield call(() => apiQueryToUploadDataRegional.post(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }));
    if (resp.status !== 200) {
      throw new Error(`Upload failed: ${resp.status}`);
    }

    yield put(adminUploadFileSuccess({ requestId, response: resp.data || 'Uploaded' }));
  } catch (error) {
    yield put(adminUploadFileFailure({ requestId: action.payload?.requestId, error: error.message }));
  }
}

// ARC download is fire-and-forget: the endpoint returns 200 immediately and the backend
// keeps processing afterwards. Once the batch-status poll reports the batch left "Initiated",
// poll GetTotalUploadFileCount until the upload status reaches a terminal ARC value
// ("Submitted by ARC"/"Submitted…" or "Download Error (ARC)"). Intermediate values such as
// "Files Uploaded" surface first and must NOT stop the poll, otherwise the row would show no
// status between the download finishing and the final status arriving. The cap bounds the wait.
const ARC_STATUS_POLL_INTERVAL_MS = 5000;
const ARC_STATUS_POLL_MAX_ATTEMPTS = 24;

// The ARC upload status is only final once the backend reports a submitted outcome
// ("Submitted by ARC"/"Submitted…") or a hard "Download Error (ARC)". Everything else is an
// intermediate step the row should keep rendering as "Downloading…"/"Syncing...".
const isTerminalArcUploadStatus = (value) => {
  const normalized = String(value ?? "").trim().toLowerCase();
  return normalized.startsWith("submitted") || normalized === "download error (arc)";
};
// After the ARC download is accepted the backend first prepares the batch. Poll
// ArcArchives/DownloadBatchStatus every 5s while it reports "Initiated"; once it moves past
// that (or the response can't be read) fall through to the real upload-status refresh. The
// cap keeps the loop from running forever if the batch never leaves "Initiated".
const ARC_BATCH_STATUS_INITIATED = "initiated";
const ARC_BATCH_STATUS_POLL_MAX_ATTEMPTS = 60;

// The ARC archive service lives on its own host (REACT_APP_ARC_ARCHIVE_API_URL_*),
// resolved by region the same way as the regional API URLs.
// A bulk ARC download passes the selected engagements as one comma-separated string;
// split it back into individual ids so each engagement can be polled on its own.
const parseArcIdList = (value) => String(value ?? '').split(',').map((part) => part.trim()).filter(Boolean);

const resolveArcBaseUrl = (areaName) => {
  const a = (areaName || '').toLowerCase();
  if (a === 'americas') return process.env.REACT_APP_ARC_ARCHIVE_API_URL_US;
  if (a === 'emeia') return process.env.REACT_APP_ARC_ARCHIVE_API_URL_EU;
  if (a === 'apac') return process.env.REACT_APP_ARC_ARCHIVE_API_URL_AU;
  return process.env.REACT_APP_ARC_ARCHIVE_API_URL_US;
};

// DownloadBatchStatus responds with an array like [{ "DownloadStatus": "Initiated" }].
// Read it defensively: unwrap the first array element and fall back to a plain string body
// or the other common status-bearing field names.
const extractArcBatchStatus = (data) => {
  if (data == null) return null;
  if (typeof data === 'string') return data.trim();
  const record = Array.isArray(data) ? data[0] : data;
  if (record == null) return null;
  if (typeof record === 'string') return record.trim();
  const raw =
    record.DownloadStatus ??
    record.downloadStatus ??
    record.status ??
    record.batchStatus ??
    record.downloadBatchStatus ??
    record.batchDownloadStatus ??
    record.Status ??
    null;
  return typeof raw === 'string' ? raw.trim() : raw;
};

function* pollArcArchiveUploadStatus(item) {
  for (let attempt = 0; attempt < ARC_STATUS_POLL_MAX_ATTEMPTS; attempt += 1) {
    let statusValue = null;
    try {
      const response = yield* postUploadCountWithRetry(item, false);
      const arr = response?.data;
      if (Array.isArray(arr) && arr.length > 0) {
        const rec = arr[0];
        statusValue = rec?.uploaD_STATUS ?? rec?.uploadStatus ?? rec?.status ?? null;
        if (typeof statusValue === 'string') {
          statusValue = statusValue.trim();
        }
        yield put(partnersUploadCountsSuccess({
          engagementId_GUID: rec.engagementId_GUID || item.engagementId_GUID,
          totalPendingFile: rec.totalPendingFile,
          noOfUploadedFiles: rec.noOfUploadedFiles,
          uploaD_STATUS: statusValue,
          _version: ++uploadCountsVersion
        }));
      }
    } catch (e) {
      // Ignore transient errors and keep retrying until a status is read or the cap.
    }
    // Stop only once the upload status is terminal. Intermediate values ("Files Uploaded",
    // etc.) and empty responses fall through and retry until a terminal status or the cap, so
    // the row keeps showing "Downloading…"/"Syncing..." until the ARC outcome is final.
    if (isTerminalArcUploadStatus(statusValue)) {
      break;
    }
    if (attempt < ARC_STATUS_POLL_MAX_ATTEMPTS - 1) {
      yield delay(ARC_STATUS_POLL_INTERVAL_MS);
    }
  }
}

// Poll ArcArchives/DownloadBatchStatus until the batch leaves the "Initiated" state. While it
// stays "Initiated" the engagement row keeps showing the existing "Syncing..." indicator.
function* pollArcDownloadBatchStatus({ engagementId, area }) {
  if (!engagementId) return;
  const url = `${ENDPOINT.PARTNERS_ARC_DOWNLOAD_BATCH_STATUS.replace(
    "baseUrl",
    resolveArcBaseUrl(area)
  )}?EngagementCode=${encodeURIComponent(engagementId)}`;
  for (let attempt = 0; attempt < ARC_BATCH_STATUS_POLL_MAX_ATTEMPTS; attempt += 1) {
    let statusValue = null;
    try {
      const response = yield call(() => apiQueryToUploadDataRegional.get(url));
      statusValue = extractArcBatchStatus(response?.data);
    } catch (e) {
      // Status is unreadable; stop polling and let the upload-status refresh take over.
      return;
    }
    if (
      typeof statusValue !== 'string' ||
      statusValue.toLowerCase() !== ARC_BATCH_STATUS_INITIATED
    ) {
      return; // batch has moved past "Initiated" -> show the actual upload status
    }
    if (attempt < ARC_BATCH_STATUS_POLL_MAX_ATTEMPTS - 1) {
      yield delay(ARC_STATUS_POLL_INTERVAL_MS);
    }
  }
}

// ARC archive download (dedicated ARC archive host, multipart form-data)
function* getPartnersDownloadArcArchivesSaga(action) {
  const { engagementId_GUID, engagementId, email, area } = action.payload || {};
  try {
    const formData = new FormData();
    formData.append('EngagementId', engagementId ?? '');
    formData.append('UserEmailID', email ?? '');

    // apiQueryToUploadDataRegional takes a full URL and does not force a JSON Content-Type.
    const url = ENDPOINT.PARTNERS_DOWNLOAD_ARC_ARCHIVES.replace(
      "baseUrl",
      resolveArcBaseUrl(area)
    );
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
    );
    if (response.status !== 200) {
      throw new Error(`ARC download failed: ${response.status}`);
    }

    yield put(partnersDownloadArcArchivesSuccess({ engagementId_GUID }));
    // A bulk download passes several engagements in one comma-separated payload; poll each
    // one so every row reflects its own final status. ARC first prepares the batch: poll
    // DownloadBatchStatus until it leaves "Initiated" (the row keeps showing "Syncing..."
    // meanwhile), then refresh the actual upload status/counts (GetTotalUploadFileCount).
    const guidList = parseArcIdList(engagementId_GUID);
    const engIdList = parseArcIdList(engagementId);
    for (let i = 0; i < guidList.length; i += 1) {
      const singleGuid = guidList[i];
      const singleEngId = engIdList[i] ?? '';
      if (singleEngId) {
        yield call(pollArcDownloadBatchStatus, { engagementId: singleEngId, area });
      }
      yield call(pollArcArchiveUploadStatus, { engagementId_GUID: singleGuid, area });
      // Clear the ARC "syncing" marker so the row stops showing "Syncing..." and renders the
      // actual upload status (e.g. "Files Uploaded") that GetTotalUploadFileCount returned.
      yield put(resetPartnersDownloadArcArchives({ engagementId_GUID: singleGuid }));
    }
  } catch (error) {
    yield put(partnersDownloadArcArchivesFailure({ engagementId_GUID, error: error.message }));
    // The download request failed, but each affected engagement's upload status/counts can still
    // have changed (and in any case need re-reading) - refresh them so the Upload Status column
    // shows the real backend state instead of the stale pre-download counts, then clear the
    // in-progress marker (the component re-fetches each engagement's failed files once the marker
    // clears, which drives the "Download Error"/"Failed" badge). A single GetTotalUploadFileCount
    // read is used here, not the success path's poll-to-terminal, because a failed download will
    // not advance to a terminal status.
    const failedGuidList = parseArcIdList(engagementId_GUID);
    for (let i = 0; i < failedGuidList.length; i += 1) {
      const singleGuid = failedGuidList[i];
      // shouldRateLimit=false mirrors the success path's post-download refresh (no rate-limit
      // gap); force=true bypasses the dedup window so the refresh is not dropped.
      yield call(fetchSingleUploadCount, { engagementId_GUID: singleGuid, area }, false, true);
      yield put(resetPartnersDownloadArcArchives({ engagementId_GUID: singleGuid }));
    }
  }
}

// Admin gold counts (Gold Layer processed vs total)
function* getAdminGoldCountsSaga() {
  try {
    const response = yield call(() => apiQueryWithToken.get(ENDPOINT.ADMIN_COUNT_GOLD_DATA));
    yield put(adminGoldCountsSuccess(response?.data));
  } catch (error) {
    yield put(adminGoldCountsFailure(error.message));
  }
}

// Admin bookmark toggle
function* adminBookmarkFileSaga(action) {
  try {
    const { controlId, isBookmarked, engagementGUID, area } = action.payload || {};
    if (controlId === undefined || controlId === null) return;
    const payload = { controlId, isBookmarked: !!isBookmarked };
    const resolveBaseUrl = (areaName) => {
      const a = (areaName || '').toLowerCase();
      if (a === 'americas') return process.env.REACT_APP_API_URL_US;
      if (a === 'emeia') return process.env.REACT_APP_API_URL_EU;
      if (a === 'apac') return process.env.REACT_APP_API_URL_AU;
      return process.env.REACT_APP_API_URL_US;
    };
    const base = resolveBaseUrl(area);
    const url = `${base}/${ENDPOINT.ADMIN_BOOKMARK_FILE}`;
    const response = yield call(() => apiQueryWithToken.post(url, payload));
    const ok = response?.data === true || response?.data === 'true' || response?.status === 200;
    if (!ok) throw new Error('Bookmark API returned failure');
    yield put(adminBookmarkFileSuccess({ controlId, isBookmarked: !!isBookmarked, engagementGUID }));
  } catch (error) {
    yield put(adminBookmarkFileFailure({ controlId: action.payload?.controlId, error: error.message, engagementGUID: action.payload?.engagementGUID }));
  }
}

function* getFilesEngagement(action) {
  try {
    const response = yield call(() =>
      apiQueryWithToken.post(
        ENDPOINT.GET_PARTNERS_FILES_ENGAGEMENT,
        action.payload
      )
    );
    const responseData = response.data;
    yield put(getFilesEngagementDataSuccess(responseData));
  } catch (error) {
    yield put(getFilesEngagementDataFailure(error.message));
  }
}

function* getPartnerFilesBlocklist() {
  try {
    const response = yield call(() =>
      apiQueryWithToken.get(ENDPOINT.GET_PARTNERS_FILES_BLOCKLIST)
    );
    const responseData = response.data;
    yield put(getPartnerFilesBlocklistDataSuccess(responseData));
  } catch (error) {
    yield put(getPartnerFilesBlocklistDataFailure(error.message));
  }
}

function* getPartnersEditEngagementDetailsUS(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.GET_PARTNERS_EDITENGAGEMENTDETAILS.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_US
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(getPartnersEditEngagementDetailsSuccess(responseData));
  } catch (error) {
    yield put(getPartnersEditEngagementDetailsFailure(error.message));
  }
}

function* getPartnersEditEngagementDetailsEU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.GET_PARTNERS_EDITENGAGEMENTDETAILS.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_EU
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(getPartnersEditEngagementDetailsSuccess(responseData));
  } catch (error) {
    yield put(getPartnersEditEngagementDetailsFailure(error.message));
  }
}

function* getPartnersEditEngagementDetailsAU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.GET_PARTNERS_EDITENGAGEMENTDETAILS.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_AU
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(getPartnersEditEngagementDetailsSuccess(responseData));
  } catch (error) {
    yield put(getPartnersEditEngagementDetailsFailure(error.message));
  }
}

function* getPartnerFileValidationUS(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.GET_PARTNERS_FILEVALIDATION.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_US
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(getPartnersFileValidationSuccess(responseData));
  } catch (error) {
    yield put(getPartnersFileValidationFailure(error.message));
  }
}

function* getPartnerFileValidationEU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.GET_PARTNERS_FILEVALIDATION.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_EU
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(getPartnersFileValidationSuccess(responseData));
  } catch (error) {
    yield put(getPartnersFileValidationFailure(error.message));
  }
}

function* getPartnerFileValidationAU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.GET_PARTNERS_FILEVALIDATION.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_AU
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(getPartnersFileValidationSuccess(responseData));
  } catch (error) {
    yield put(getPartnersFileValidationFailure(error.message));
  }
}

function* getPartnerFilesDownloadUS(action) {
  try {
    const response = yield call(() =>
      apiQueryToDownloadData.post(
        ENDPOINT.GET_PARTNERS_DOWNLOADFILECONTENT.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_US
        ),
        action.payload
      )
    );

    yield put(getPartnersFilesDownloadSuccess(response.data));
  } catch (error) {
    yield put(getPartnersFilesDownloadFailure(error.message));
  }
}

function* getPartnerFilesDownloadEU(action) {
  try {
    const response = yield call(() =>
      apiQueryToDownloadData.post(
        ENDPOINT.GET_PARTNERS_DOWNLOADFILECONTENT.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_EU
        ),
        action.payload
      )
    );

    yield put(getPartnersFilesDownloadSuccess(response.data));
  } catch (error) {
    yield put(getPartnersFilesDownloadFailure(error.message));
  }
}

function* getPartnerFilesDownloadAU(action) {
  try {
    const response = yield call(() =>
      apiQueryToDownloadData.post(
        ENDPOINT.GET_PARTNERS_DOWNLOADFILECONTENT.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_AU
        ),
        action.payload
      )
    );

    yield put(getPartnersFilesDownloadSuccess(response.data));
  } catch (error) {
    yield put(getPartnersFilesDownloadFailure(error.message));
  }
}

function* getPartnerFilesDeleteUS(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.GET_PARTNERS_FILES_DELETE.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_US
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(getPartnersFilesDeleteSuccess(responseData));
  } catch (error) {
    yield put(getPartnersFilesDeleteFailure(error.message));
  }
}

function* getPartnerFilesDeleteEU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.GET_PARTNERS_FILES_DELETE.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_EU
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(getPartnersFilesDeleteSuccess(responseData));
  } catch (error) {
    yield put(getPartnersFilesDeleteFailure(error.message));
  }
}

function* getPartnerFilesDeleteAU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.GET_PARTNERS_FILES_DELETE.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_AU
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(getPartnersFilesDeleteSuccess(responseData));
  } catch (error) {
    yield put(getPartnersFilesDeleteFailure(error.message));
  }
}

function* getPartnerViewFilesContentUS(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.GET_PARTNERS_VIEWFILESCONTENT.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_US
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(getPartnersViewFilesContentSuccess(responseData));
  } catch (error) {
    yield put(getPartnersViewFilesContentFailure(error.message));
  }
}

function* getPartnerViewFilesContentEU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.GET_PARTNERS_VIEWFILESCONTENT.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_EU
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(getPartnersViewFilesContentSuccess(responseData));
  } catch (error) {
    yield put(getPartnersViewFilesContentFailure(error.message));
  }
}

function* getPartnerViewFilesContentAU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.GET_PARTNERS_VIEWFILESCONTENT.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_AU
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(getPartnersViewFilesContentSuccess(responseData));
  } catch (error) {
    yield put(getPartnersViewFilesContentFailure(error.message));
  }
}

function* getPartnerDeleteTempFilesOnPopupCloseUS(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_DELETE_TEMP_FILES_ON_POPUP_CLOSE.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_US
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(PartnersDeleteTempFilesOnPopupCloseSuccess(responseData));
  } catch (error) {
    yield put(PartnersDeleteTempFilesOnPopupCloseFailure(error.message));
  }
}

function* getPartnerDeleteTempFilesOnPopupCloseEU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_DELETE_TEMP_FILES_ON_POPUP_CLOSE.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_EU
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(PartnersDeleteTempFilesOnPopupCloseSuccess(responseData));
  } catch (error) {
    yield put(PartnersDeleteTempFilesOnPopupCloseFailure(error.message));
  }
}

function* getPartnerDeleteTempFilesOnPopupCloseAU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_DELETE_TEMP_FILES_ON_POPUP_CLOSE.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_AU
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(PartnersDeleteTempFilesOnPopupCloseSuccess(responseData));
  } catch (error) {
    yield put(PartnersDeleteTempFilesOnPopupCloseFailure(error.message));
  }
}

function* getPartnerEditEngagementStatusUS(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_EDIT_ENGAGEMENT_STATUS.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_US
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersEditEngagementStatusSuccess(responseData));
  } catch (error) {
    yield put(partnersEditEngagementStatusFailure(error.message));
  }
}

function* getPartnerEditEngagementStatusEU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_EDIT_ENGAGEMENT_STATUS.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_EU
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersEditEngagementStatusSuccess(responseData));
  } catch (error) {
    yield put(partnersEditEngagementStatusFailure(error.message));
  }
}

function* getPartnerEditEngagementStatusAU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_EDIT_ENGAGEMENT_STATUS.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_AU
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersEditEngagementStatusSuccess(responseData));
  } catch (error) {
    yield put(partnersEditEngagementStatusFailure(error.message));
  }
}

function* getPartnersSasTokenUS(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_SAS_TOKEN.replace("baseUrl", process.env.REACT_APP_API_URL_US),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersSasTokenSuccess(responseData));
  } catch (error) {
    yield put(partnersSasTokenFailure(error.message));
  }
}

function* getPartnersSasTokenEU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_SAS_TOKEN.replace("baseUrl", process.env.REACT_APP_API_URL_EU),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersSasTokenSuccess(responseData));
  } catch (error) {
    yield put(partnersSasTokenFailure(error.message));
  }
}

function* getPartnersSasTokenAU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_SAS_TOKEN.replace("baseUrl", process.env.REACT_APP_API_URL_AU),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersSasTokenSuccess(responseData));
  } catch (error) {
    yield put(partnersSasTokenFailure(error.message));
  }
}

function* getPartnersUploadProcessingUS(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_UPLOAD_PROCESSING.replace("baseUrl", process.env.REACT_APP_API_URL_US),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersUploadProcessingSuccess(responseData));
  } catch (error) {
    yield put(partnersUploadProcessingFailure(error.message));
  }
}
function* getPartnersUploadProcessingEU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_UPLOAD_PROCESSING.replace("baseUrl", process.env.REACT_APP_API_URL_EU),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersUploadProcessingSuccess(responseData));
  } catch (error) {
    yield put(partnersUploadProcessingFailure(error.message));
  }
}
function* getPartnersUploadProcessingAU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_UPLOAD_PROCESSING.replace("baseUrl", process.env.REACT_APP_API_URL_AU),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersUploadProcessingSuccess(responseData));
  } catch (error) {
    yield put(partnersUploadProcessingFailure(error.message));
  }
}
function* getPartnersUploadReProcessingUS(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_UPLOAD_REPROCESSING.replace("baseUrl", process.env.REACT_APP_API_URL_US),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersUploadReProcessingSuccess(responseData));
  } catch (error) {
    yield put(partnersUploadReProcessingFailure(error.message));
  }
}
function* getPartnersUploadReProcessingEU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_UPLOAD_REPROCESSING.replace("baseUrl", process.env.REACT_APP_API_URL_EU),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersUploadReProcessingSuccess(responseData));
  } catch (error) {
    yield put(partnersUploadReProcessingFailure(error.message));
  }
}
function* getPartnersUploadReProcessingAU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_UPLOAD_REPROCESSING.replace("baseUrl", process.env.REACT_APP_API_URL_AU),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersUploadReProcessingSuccess(responseData));
  } catch (error) {
    yield put(partnersUploadReProcessingFailure(error.message));
  }
}

function* getPartnerUploadSharePointFilesToBlobUS(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_UPLOAD_SHAREPOINT_FILES_TO_BLOB.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_US
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersUploadSharePointFilesToBlobSuccess(responseData));
  } catch (error) {
    yield put(partnersUploadSharePointFilesToBlobFailure(error.message));
  }
}

function* getPartnerUploadSharePointFilesToBlobEU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_UPLOAD_SHAREPOINT_FILES_TO_BLOB.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_EU
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersUploadSharePointFilesToBlobSuccess(responseData));
  } catch (error) {
    yield put(partnersUploadSharePointFilesToBlobFailure(error.message));
  }
}

function* getPartnerUploadSharePointFilesToBlobAU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_UPLOAD_SHAREPOINT_FILES_TO_BLOB.replace(
          "baseUrl",
          process.env.REACT_APP_API_URL_AU
        ),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersUploadSharePointFilesToBlobSuccess(responseData));
  } catch (error) {
    yield put(partnersUploadSharePointFilesToBlobFailure(error.message));
  }
}

function* getPartnersAccessGrantUS(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_ACCESS_GRANT.replace("baseUrl", process.env.REACT_APP_API_URL_US),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersAccessGrantSuccess(responseData));
  } catch (error) {
    yield put(partnersAccessGrantFailure(error.message));
  }
}

function* getPartnersAccessGrantEU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_ACCESS_GRANT.replace("baseUrl", process.env.REACT_APP_API_URL_EU),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersAccessGrantSuccess(responseData));
  } catch (error) {
    yield put(partnersAccessGrantFailure(error.message));
  }
}

function* getPartnersAccessGrantAU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_ACCESS_GRANT.replace("baseUrl", process.env.REACT_APP_API_URL_AU),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersAccessGrantSuccess(responseData));
  } catch (error) {
    yield put(partnersAccessGrantFailure(error.message));
  }
}

function* getPartnersAccessRevokeUS(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_ACCESS_REVOKE.replace("baseUrl", process.env.REACT_APP_API_URL_US),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersAccessRevokeSuccess(responseData));
  } catch (error) {
    yield put(partnersAccessRevokeFailure(error.message));
  }
}

function* getPartnersAccessRevokeEU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_ACCESS_REVOKE.replace("baseUrl", process.env.REACT_APP_API_URL_EU),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersAccessRevokeSuccess(responseData));
  } catch (error) {
    yield put(partnersAccessRevokeFailure(error.message));
  }
}

function* getPartnersAccessRevokeAU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_ACCESS_REVOKE.replace("baseUrl", process.env.REACT_APP_API_URL_AU),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersAccessRevokeSuccess(responseData));
  } catch (error) {
    yield put(partnersAccessRevokeFailure(error.message));
  }
}

function* partnerUploadedFileStatusRequestUS(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_UPLOADED_FILE_STATUS.replace("baseUrl", process.env.REACT_APP_API_URL_US),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersUploadedFileStatusSuccess(responseData));
  } catch (error) {
    yield put(partnersUploadedFileStatusFailure(error.message));
  }
}

function* partnerUploadedFileStatusRequestEU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_UPLOADED_FILE_STATUS.replace("baseUrl", process.env.REACT_APP_API_URL_EU),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersUploadedFileStatusSuccess(responseData));
  } catch (error) {
    yield put(partnersUploadedFileStatusFailure(error.message));
  }
}

function* partnerUploadedFileStatusRequestAU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_UPLOADED_FILE_STATUS.replace("baseUrl", process.env.REACT_APP_API_URL_AU),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersUploadedFileStatusSuccess(responseData));
  } catch (error) {
    yield put(partnersUploadedFileStatusFailure(error.message));
  }
}

function* partnerDuplicateFilesRequestUS(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_DUPLICATE_FILES.replace("baseUrl", process.env.REACT_APP_API_URL_US),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersDuplicateFilesSuccess(responseData));
  } catch (error) {
    yield put(partnersDuplicateFilesFailure(error.message));
  }
}

function* partnerDuplicateFilesRequestEU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_DUPLICATE_FILES.replace("baseUrl", process.env.REACT_APP_API_URL_EU),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersDuplicateFilesSuccess(responseData));
  } catch (error) {
    yield put(partnersDuplicateFilesFailure(error.message));
  }
}

function* partnerDuplicateFilesRequestAU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_DUPLICATE_FILES.replace("baseUrl", process.env.REACT_APP_API_URL_AU),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersDuplicateFilesSuccess(responseData));
  } catch (error) {
    yield put(partnersDuplicateFilesFailure(error.message));
  }
}

function* partnerEnableDisableClientDataRequestUS(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_ENABLE_DISABLE_CLIENT_DATA.replace("baseUrl", process.env.REACT_APP_API_URL_US),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersEnableDisableClientDataSuccess(responseData));
  } catch (error) {
    yield put(partnersEnableDisableClientDataFailure(error.message));
  }
}

function* partnerEnableDisableClientDataRequestEU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_ENABLE_DISABLE_CLIENT_DATA.replace("baseUrl", process.env.REACT_APP_API_URL_EU),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersEnableDisableClientDataSuccess(responseData));
  } catch (error) {
    yield put(partnersEnableDisableClientDataFailure(error.message));
  }
}

function* partnerEnableDisableClientDataRequestAU(action) {
  try {
    const response = yield call(() =>
      apiQueryToUploadDataRegional.post(
        ENDPOINT.PARTNERS_ENABLE_DISABLE_CLIENT_DATA.replace("baseUrl", process.env.REACT_APP_API_URL_AU),
        action.payload
      )
    );
    const responseData = response.data;
    yield put(partnersEnableDisableClientDataSuccess(responseData));
  } catch (error) {
    yield put(partnersEnableDisableClientDataFailure(error.message));
  }
}

function* partnerErrorSaveRequest(action) {
  try {
    const response = yield call(() =>
      apiQueryWithToken.post(ENDPOINT.PARTNERS_ERROR_SAVE, action.payload)
    );
    const responseData = response.data;
    yield put(partnersErrorSaveDataSuccess(responseData));
  } catch (error) {
    yield put(partnersErrorSaveDataFailure(error.message));
  }
}

function* getPlannedOutagePriorRequestSaga() {
  try {
    const response = yield call(() =>
      apiQueryWithToken.get(ENDPOINT.GET_PLANNED_OUTAGE_PRIOR)
    );
    // API returns 204 No Content when no upcoming outage is scheduled
    const responseData = response?.status === 204 ? null : (response?.data || null);
    yield put(getPlannedOutagePriorSuccess(responseData));
  } catch (error) {
    yield put(getPlannedOutagePriorFailure(error.message));
  }
}

function* getPlannedOutageActiveRequestSaga() {
  try {
    const response = yield call(() =>
      apiQueryWithToken.get(ENDPOINT.GET_PLANNED_OUTAGE_ACTIVE)
    );
    // API returns 204 No Content when no active outage exists
    const responseData = response?.status === 204 ? null : (response?.data || null);
    yield put(getPlannedOutageActiveSuccess(responseData));
  } catch (error) {
    yield put(getPlannedOutageActiveFailure(error.message));
  }
}

function* watchUtilityData() {
  yield takeLatest(getUtilityData.type, getUtilityDatas);
  yield takeLatest(getUtilityDataSuccess.type, seedUploadCountsFromUtility);
}

// Watcher for single engagement upload count refresh
function* watchSingleUploadCount() {
  // takeEvery (not takeLatest) so a refresh for one engagement is not cancelled by a refresh
  // requested for another one; duplicates are already filtered inside fetchSingleUploadCount.
  yield takeEvery(partnersUploadCountSingleRequest.type, function* single(action) {
    const item = action.payload; // { engagementId_GUID, area, force }
    if (item?.engagementId_GUID) {
      const force = item.force === true;
      yield call(fetchSingleUploadCount, item, !force, force);
    }
  });
}

// Watcher: ARC archive download requests (takeEvery so multiple rows don't cancel each other)
function* watchPartnersDownloadArcArchives() {
  yield takeEvery(partnersDownloadArcArchivesRequest.type, getPartnersDownloadArcArchivesSaga);
}

function* watchAdminEngagementData() {
  yield takeLatest(getAdminEngagementData.type, getAdminEngagementDatas);
}

function* watchAdminFilesData() {
  yield takeLatest(getAdminFilesData.type, getAdminFilesDatas);
}

function* watchAdminOriginalFileNamesData() {
  yield takeLatest(adminOriginalFileNamesRequest.type, getAdminOriginalFileNamesDatas);
}

function* watchAdminStartAnonymizationData() {
  yield takeLatest(adminStartAnonymizationRequest.type, getAdminStartAnonymizationDatas);
}

function* watchAdminDownloadFile() {
  yield takeLatest(adminDownloadFileRequest.type, adminDownloadFileSaga);
}

function* watchAdminExportExcel() {
  yield takeLatest(adminExportExcelRequest.type, adminExportExcelSaga);
}

function* watchAdminUploadFile() {
  yield takeLatest(adminUploadFileRequest.type, adminUploadFileSaga);
}

function* watchAdminGoldCounts() {
  yield takeLatest(adminGoldCountsRequest.type, getAdminGoldCountsSaga);
}

function* watchAdminBookmarkFile() {
  yield takeLatest(adminBookmarkFileRequest.type, adminBookmarkFileSaga);
}

function* watchFilesEngagementData() {
  yield takeLatest(getFilesEngagementData.type, getFilesEngagement);
}

function* watchPartnerFilesBlocklistData() {
  yield takeLatest(getPartnerFilesBlocklistData.type, getPartnerFilesBlocklist);
}

function* watchPartnersEditEngagementDetails() {
  yield takeLatest(
    getPartnerEditEngagementDetailsUS.type,
    getPartnersEditEngagementDetailsUS
  );
  yield takeLatest(
    getPartnerEditEngagementDetailsEU.type,
    getPartnersEditEngagementDetailsEU
  );
  yield takeLatest(
    getPartnerEditEngagementDetailsAU.type,
    getPartnersEditEngagementDetailsAU
  );
}

function* watchPartnersFileValidation() {
  yield takeLatest(
    getPartnersFileValidationUS.type,
    getPartnerFileValidationUS
  );
  yield takeLatest(
    getPartnersFileValidationEU.type,
    getPartnerFileValidationEU
  );
  yield takeLatest(
    getPartnersFileValidationAU.type,
    getPartnerFileValidationAU
  );
}

function* watchPartnersFilesDelete() {
  yield takeLatest(getPartnersFilesDeleteUS.type, getPartnerFilesDeleteUS);
  yield takeLatest(getPartnersFilesDeleteEU.type, getPartnerFilesDeleteEU);
  yield takeLatest(getPartnersFilesDeleteAU.type, getPartnerFilesDeleteAU);
}

function* watchPartnersFilesDownload() {
  yield takeLatest(getPartnersFilesDownloadUS.type, getPartnerFilesDownloadUS);
  yield takeLatest(getPartnersFilesDownloadEU.type, getPartnerFilesDownloadEU);
  yield takeLatest(getPartnersFilesDownloadAU.type, getPartnerFilesDownloadAU);
}

function* watchPartnersViewFilesContent() {
  yield takeLatest(
    getPartnersViewFilesContentUS.type,
    getPartnerViewFilesContentUS
  );
  yield takeLatest(
    getPartnersViewFilesContentEU.type,
    getPartnerViewFilesContentEU
  );
  yield takeLatest(
    getPartnersViewFilesContentAU.type,
    getPartnerViewFilesContentAU
  );
}

function* watchPartnersDeleteTempFilesOnPopupClose() {
  yield takeLatest(
    PartnersDeleteTempFilesOnPopupCloseUS.type,
    getPartnerDeleteTempFilesOnPopupCloseUS
  );
  yield takeLatest(
    PartnersDeleteTempFilesOnPopupCloseEU.type,
    getPartnerDeleteTempFilesOnPopupCloseEU
  );
  yield takeLatest(
    PartnersDeleteTempFilesOnPopupCloseAU.type,
    getPartnerDeleteTempFilesOnPopupCloseAU
  );
}

function* watchPartnersEditEngagementStatus() {
  yield takeLatest(
    partnersEditEngagementStatusUS.type,
    getPartnerEditEngagementStatusUS
  );
  yield takeLatest(
    partnersEditEngagementStatusEU.type,
    getPartnerEditEngagementStatusEU
  );
  yield takeLatest(
    partnersEditEngagementStatusAU.type,
    getPartnerEditEngagementStatusAU
  );
};

function* watchPartnersSasToken() {
  yield takeLatest(partnersSasTokenUS.type, getPartnersSasTokenUS);
  yield takeLatest(partnersSasTokenEU.type, getPartnersSasTokenEU);
  yield takeLatest(partnersSasTokenAU.type, getPartnersSasTokenAU);
};

function* watchPartnersUploadProcessing() {
  yield takeLatest(partnersUploadProcessingUS.type, getPartnersUploadProcessingUS);
  yield takeLatest(partnersUploadProcessingEU.type, getPartnersUploadProcessingEU);
  yield takeLatest(partnersUploadProcessingAU.type, getPartnersUploadProcessingAU);
};

function* watchPartnersUploadReProcessing() {
  yield takeLatest(partnersUploadReProcessingUS.type, getPartnersUploadReProcessingUS);
  yield takeLatest(partnersUploadReProcessingEU.type, getPartnersUploadReProcessingEU);
  yield takeLatest(partnersUploadReProcessingAU.type, getPartnersUploadReProcessingAU);
};

// When processing completes (success action), trigger refresh for involved engagements

function* watchPartnersUploadSharePointFilesToBlob() {
  yield takeLatest(
    partnersUploadSharePointFilesToBlobUS.type,
    getPartnerUploadSharePointFilesToBlobUS
  );
  yield takeLatest(
    partnersUploadSharePointFilesToBlobEU.type,
    getPartnerUploadSharePointFilesToBlobEU
  );
  yield takeLatest(
    partnersUploadSharePointFilesToBlobAU.type,
    getPartnerUploadSharePointFilesToBlobAU
  );
}

function* watchPartnersAccessGrant() {
  yield takeLatest(partnersAccessGrantUS.type, getPartnersAccessGrantUS);
  yield takeLatest(partnersAccessGrantEU.type, getPartnersAccessGrantEU);
  yield takeLatest(partnersAccessGrantAU.type, getPartnersAccessGrantAU);
}

function* watchPartnersAccessRevoke() {
  yield takeLatest(partnersAccessRevokeUS.type, getPartnersAccessRevokeUS);
  yield takeLatest(partnersAccessRevokeEU.type, getPartnersAccessRevokeEU);
  yield takeLatest(partnersAccessRevokeAU.type, getPartnersAccessRevokeAU);
}

function* watchPartnersUploadedFileStatus() {
  yield takeLatest(
    partnersUploadedFileStatusRequestUS.type,
    partnerUploadedFileStatusRequestUS
  );
  yield takeLatest(
    partnersUploadedFileStatusRequestEU.type,
    partnerUploadedFileStatusRequestEU
  );
  yield takeLatest(
    partnersUploadedFileStatusRequestAU.type,
    partnerUploadedFileStatusRequestAU
  );
}

function* watchPartnersDuplicateFiles() {
  yield takeLatest(
    partnersDuplicateFilesRequestUS.type,
    partnerDuplicateFilesRequestUS
  );
  yield takeLatest(
    partnersDuplicateFilesRequestEU.type,
    partnerDuplicateFilesRequestEU
  );
  yield takeLatest(
    partnersDuplicateFilesRequestAU.type,
    partnerDuplicateFilesRequestAU
  );
}

function* watchPartnersEnableDisableClientData() {
  yield takeLatest(
    partnersEnableDisableClientDataRequestUS.type,
    partnerEnableDisableClientDataRequestUS
  );
  yield takeLatest(
    partnersEnableDisableClientDataRequestEU.type,
    partnerEnableDisableClientDataRequestEU
  );
  yield takeLatest(
    partnersEnableDisableClientDataRequestAU.type,
    partnerEnableDisableClientDataRequestAU
  );
}

function* watchPartnersSaveErrorData() {
  yield takeLatest(partnersErrorSaveDataRequest.type, partnerErrorSaveRequest);
}

function* watchPlannedOutagePrior() {
  yield takeLatest(getPlannedOutagePriorRequest.type, getPlannedOutagePriorRequestSaga);
}

function* watchPlannedOutageActive() {
  yield takeLatest(getPlannedOutageActiveRequest.type, getPlannedOutageActiveRequestSaga);
}

const PartnerFilesagas = {
  watchUtilityData,
  watchAdminEngagementData,
  watchAdminFilesData,
  watchAdminOriginalFileNamesData,
  watchAdminStartAnonymizationData,
  watchAdminUploadFile,
  watchAdminDownloadFile,
  watchAdminExportExcel,
  watchSingleUploadCount,
  watchPartnersDownloadArcArchives,
  watchFilesEngagementData,
  watchPartnerFilesBlocklistData,
  watchPartnersEditEngagementDetails,
  watchPartnersFileValidation,
  watchPartnersFilesDelete,
  watchPartnersFilesDownload,
  watchPartnersViewFilesContent,
  watchPartnersDeleteTempFilesOnPopupClose,
  watchPartnersEditEngagementStatus,
  watchPartnersSasToken,
  watchPartnersUploadProcessing,
  watchPartnersUploadReProcessing,
  watchPartnersUploadSharePointFilesToBlob,
  watchPartnersAccessGrant,
  watchPartnersAccessRevoke,
  watchAdminGoldCounts,
  watchAdminBookmarkFile,
  watchPartnersUploadedFileStatus,
  watchPartnersDuplicateFiles,
  watchPartnersEnableDisableClientData,
  watchPartnersSaveErrorData,
  watchPlannedOutagePrior,
  watchPlannedOutageActive,
};
export default PartnerFilesagas;